/**
 * sectors component
 * used in 'Detail des vols' modal
 *   @Input() journeyList: any;
 *   @Input() segmentItem: any;
 */
import { Component, Input } from '@angular/core';

@Component({
    selector: 'sectors',
    templateUrl: './sectors.component.html'
})
export class SectorsComponent {
    @Input()
    public journeyList: any;
    @Input()
    public booking: any;
    @Input()
    public segments: any;
}
